import { __ } from '@wordpress/i18n';
import { InspectorControls, useBlockProps } from '@wordpress/block-editor';
import { PanelBody, TextControl, Button } from '@wordpress/components';
import { useState } from '@wordpress/element';
import './editor.scss';
import logoImage from '../../assets/linear_logo_orange.png';

export default function Edit({ attributes, setAttributes }) {
    const blockProps = useBlockProps();
    const backgroundImage = logoImage || window.linearPluginData?.assetsUrl + 'linear_logo_orange.png';

    const dynamicParentPages = window.linear_admin_obj?.dynamic_parent_pages || {};
    const firstDynamicParentPage = Object.values(dynamicParentPages)[0] + '?guide' || '#';

    const [attributesList, setAttributesList] = useState(attributes.attributesList || []);

    const updateAttributesList = (newList) => {
        setAttributesList(newList);
        setAttributes({ attributesList: newList });
    };

    const addKeyValuePair = () => {
        updateAttributesList([...attributesList, { key: '', value: '' }]);
    };

    const updateKeyValuePair = (index, field, value) => {
        const updatedList = [...attributesList];
        updatedList[index][field] = value.replace('data-', '');
        updateAttributesList(updatedList);
    };

    const removeKeyValuePair = (index) => {
        const updatedList = attributesList.filter((_, i) => i !== index);
        updateAttributesList(updatedList);
    };

    return (
        <>
            <InspectorControls>
                <PanelBody title={__('Listings Settings', 'linear')}>
                    <p>{__('This block will display Linear listings on the frontend.', 'linear')}</p>
                    <p>{__('You can use attributes to modify both the visual identity as well as what listings are shown.', 'linear')}</p>

                    <h3>{__('Attributes', 'linear')}</h3>
                    <p>{__('All attributes added here will become data-<Attribute Name>="<Attribute Value>". See all available attributes behind the link.', 'linear')}</p> 
                    <Button
                        variant="primary"
                        href={firstDynamicParentPage}
                        target="_blank"
                        style={{ marginTop: '10px', marginBottom: '10px' }}
                    >{__('See available attributes', 'linear')}</Button>
                    {attributesList.map((item, index) => (
                        <div key={index} style={{ marginBottom: '10px' }}>
                            <TextControl
                                label={__('Attribute name', 'linear')}
                                value={item.key}
                                onChange={(value) => updateKeyValuePair(index, 'key', value)}
                                placeholder={__('eg. use-filters', 'linear')}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <TextControl
                                    label={__('Attribute value', 'linear')}
                                    value={item.value}
                                    onChange={(value) => updateKeyValuePair(index, 'value', value)}
                                    placeholder={__('eg. false', 'linear')}
                                    style={{ flex: '1', width: '100%' }}
                                />
                                <Button
                                    isDestructive
                                    onClick={() => removeKeyValuePair(index)}
                                    style={{
                                        padding: '0',
                                        background: 'none',
                                        border: 'none',
                                        color: 'red',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 384 512"
                                        width="16"
                                        height="16"
                                        fill="red"
                                    >
                                        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                                    </svg>
                                </Button>
                            </div>
                        </div>
                    ))}
                    <Button isPrimary onClick={addKeyValuePair} style={{ marginBottom: '10px' }}>
                        {__('Add attribute', 'linear')}
                    </Button>
                </PanelBody>
            </InspectorControls>

            <div {...blockProps}>
                <div
                    className="linear-block-preview"
                    style={{
                        backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
                        backgroundSize: '400px',
                        backgroundPosition: '300px 10px',
                        backgroundRepeat: 'no-repeat',
                        padding: '2rem',
                        paddingRight: '45%',
                        border: '2px solid #ef7953',
                        borderRadius: '10px',
                        minHeight: '200px',
                    }}
                >
                    <h2>{__('Linear Listings', 'linear')}</h2>
                    <p>{__('This block displays a list of property listings.', 'linear')}</p>
                    <p>{__('The actual content will be loaded on the frontend.', 'linear')}</p>
                </div>
            </div>
        </>
    );
}